import {type RunSelectorAnalyticsLocation} from '../../components/RunSelector/RunSelectorAnalyticsLocationContext';
import {makeTrackEvent} from './makeTrackEvent';

export type ToggleRunSelectorAction =
  | 'Expand run selector'
  | 'Collapse run selector';

export type ToggleRunSelectorEvent = {
  action: ToggleRunSelectorAction;
  method: 'hotkey' | 'button';
  location?: RunSelectorAnalyticsLocation;
};

export const trackToggleRunSelector = makeTrackEvent<
  ToggleRunSelectorEvent,
  {
    action: {
      description: 'the action that was toggled';
    };
    location: {
      description: 'where the action was triggered from';
    };
    method: {
      description: 'the method used to trigger the action';
    };
    _description: 'Tracks toggle activity in run selector';
    _location: 'report, runs-table, workspace, create-sweep-prior-runs, sweep-prior-runs';
    _motivation: 'track usage';
  }
>('Toggle run selector');
